import { chunk } from 'lodash'
import * as Yup from 'yup'
import { setProgress } from 'features/export_import/importExportSlice'
import {
    convertStringToList,
    LIMITED_NUMBER_OF_UPLOADED_ITEMS,
} from 'features/export_import/utils'
import { showErrorNotification } from 'features/notifications/notificationsSlice'
// @ts-ignore
import SampleFile from 'features/export_import/sample_files/sample_attendee.xlsx'
import {
    GroupMappedFields,
    ImportDataFormProps, MappedField, SampleDataType
} from 'features/export_import/types'
import { _ } from 'utils'
import { importAttendees } from './graphql/mutation'

const getGroup: () => GroupMappedFields = () => ([
    { id: 1, text: _('attendee_import.group.general') },
    { id: 2, text: _('attendee_import.group.personalization') },
    { id: 3, text: _('attendee_import.group.social') },
])

export const mappedFields: MappedField[] = [
    {
        field: 'firstName', label: 'First name', isRequired: true, groupId: 1
    },
    {
        field: 'lastName', label: 'Last name', isRequired: true, groupId: 1
    },
    {
        field: 'email', label: 'Email', isRequired: true, groupId: 1
    },
    { field: 'jobtitle', label: 'Job', groupId: 1 },
    { field: 'company', label: 'Company', groupId: 1 },
    { field: 'about', label: 'About', groupId: 1 },
    { field: 'locationType', label: 'Location type', groupId: 1 },
    { field: 'website', label: 'Website', groupId: 3 },
    { field: 'twitter', label: 'Twitter', groupId: 3 },
    { field: 'facebook', label: 'Facebook', groupId: 3 },
    { field: 'linkedin', label: 'Linkedin', groupId: 3 },
    { field: 'instagram', label: 'Instagram', groupId: 3 },
    { field: 'tags', label: 'Tags', groupId: 2 },
    { field: 'segments', label: 'Segments', groupId: 2 },
    { field: 'programExternalIds', label: 'Program external ids', groupId: 2 },
]

export const sampleData: SampleDataType[] = [
    { header: 'First name', value: 'name' },
    { header: 'Last name', value: 'name' },
    { header: 'Email', value: 'example@mail.com' },
    { header: 'Job', value: 'job' },
    { header: 'Company', value: 'company' },
    { header: 'About', value: 'about' },
    { header: 'Website', value: 'www.site.con' },
    { header: 'Twitter', value: '' },
    { header: 'Facebook', value: '' },
    { header: 'Linkedin', value: '' },
    { header: 'Instagram', value: '' },
    { header: 'Tags', value: 'tag1, tag2' },
    { header: 'Segments', value: 'vips, retailers' },
    { header: 'Program external ids', value: 'PR01, PR02' },
]

export const validationSchema = Yup.array().of(
    Yup.object().shape({
        email: Yup.string().email().required(),
        firstName: Yup.string().required(),
        lastName: Yup.string().required(),
        locationType: Yup.string().oneOf(
            ['', 'HYBRID', 'IN_PERSON', 'VIRTUAL'], 'The location type must be VIRTUAL or IN_PERSON or HYBRID'
        ),
    })
)

export const importProps: Omit<ImportDataFormProps, 'onSubmit'> = {
    mappedFields,
    getGroupMappedFields: getGroup,
    sampleData,
    sampleFile: SampleFile,
    validationSchema,
}

export const handleSubmit = async (eventSlug, data, dispatch, callback) => {
    const submittedData = data.map((e) => {
        e.tags = convertStringToList(e.tags)
        e.segments = convertStringToList(e.segments)
        e.locationType = e.locationType || 'HYBRID'

        return e
    })

    let completed = 0
    let errorItems = []
    const chunked_data = chunk(submittedData, LIMITED_NUMBER_OF_UPLOADED_ITEMS)
    // eslint-disable-next-line no-restricted-syntax
    for (const _data of chunked_data) {
        // eslint-disable-next-line no-await-in-loop
        const response = await importAttendees({ eventSlug, data: _data })
        if (response.errors.length) {
            return dispatch(showErrorNotification(response.errors))
        }
        const importResult = response.data.importInvites
        completed += LIMITED_NUMBER_OF_UPLOADED_ITEMS
        errorItems = [...errorItems, ...importResult.errorItems.map((e) => e.id)]
        dispatch(
            setProgress({
                completed: Math.min(completed, submittedData.length),
                errorItems,
            })
        )
    }
    callback?.()
}
